import { useInMemoryStorage } from '@hooks/useInMemoryStorage';
import { isAffiliator } from '@models/accounts';

export const useShareReferralCode = (): string | undefined => {
  const affiliate = useInMemoryStorage((state) => state.accountMe?.affiliate);

  if (isAffiliator(affiliate) && affiliate?.referralCode) {
    return affiliate.referralCode;
  }
  return undefined;
};
